module.exports = __webpack_public_path__ + "static/media/Family2+2.a3f14e94.svg";